module.exports = __webpack_public_path__ + "img/clapping-hands-sign.cb713c40.svg";